import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core'
import { AccountService, MIN_NEW_PASSWORD_LENGTH } from '@src/app/core/services/account.service.js'
import { PasswordLengthIndicator } from '@src/app/shared/typings/ui.js'

@Component({
  selector: 'app-password-indicator',
  templateUrl: './password-indicator.component.html',
  styleUrls: ['./password-indicator.component.scss'],
  standalone: false,
})
export class PasswordIndicatorComponent implements OnChanges {
  private accountService = inject(AccountService)
  passwordLengthIndicator = PasswordLengthIndicator.WEAK
  MIN_NEW_PASSWORD_LENGTH = MIN_NEW_PASSWORD_LENGTH

  @Input()
  password = ''

  ngOnChanges(changes: SimpleChanges): void {
    this.passwordLengthIndicator = this.accountService.getPasswordLengthIndicator(
      changes['password']?.currentValue || '',
    )
  }
}
